




























import { Component, Vue, Prop } from 'vue-property-decorator';
import dayjs from 'dayjs';

import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import TypeBox from '@/components/TypeBox/TypeBox.vue';
import { TextField } from '@/components/atoms';
import { IPeriod } from '@/models/period';
import DateUtils from '@/utils/DateUtils';
import AdminService from '@/api/AdminService';
import OfferList from './OfferList/OfferList.vue';
import eventBus from '@/utils/eventBus';
import { sleep } from '@/utils';

@Component({
  components: {
    TextField,
    SideModalHeader,
    TypeBox,
    OfferList
  }
})
export default class MenuOfferList extends Vue {
  @Prop({ required: true }) data: any;
  tab: string = 'customers';
  period: IPeriod = this.initialPeriod;

  service: AdminService = new AdminService();

  get getPicture() {
    try {
      if (!this.data.picture.includes('https')) return '';
      return {
        background: `url('${this.data.picture}')`,
        backgroundSize: 'cover'
      };
    } catch (e) {
      return 'hasNoImage';
    }
  }

  get initialPeriod() {
    return {
      end: new Date().toISOString(),
      start: dayjs()
        .utc()
        .add(-4, 'years')
        .toISOString(),
      shortcut: ''
    };
  }

  get getLabelByPeriod() {
    const { start, end } = this.period;
    const format = (date: string) => DateUtils.formattedDate({ date });

    return `${format(start)} - ${format(end)}`;
  }

  onPeriodInput(newValue: IPeriod) {
    if (newValue && newValue.start && newValue.end) {
      const value = newValue;
      value.start = `${newValue.start}Z`;
      value.end = `${newValue.end}Z`;
      value.shortcut = newValue.shortcut;

      this.period = value;
    }
  }

  closeOfferDetailModal() {
    const modalConfig = {
      isOpen: true,
      component: 'adminOfferList',
      data: this.data,
      width: '700px'
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  async openOfferDetailModal(offer: any) {
    this.closeOfferDetailModal();
    await sleep(100);
    const modalConfig = {
      isOpen: true,
      component: 'adminOfferList',
      data: { ...this.data, offer: offer, close: this.closeOfferDetailModal },
      width: '700px',
      subModal: {
        isOpen: true,
        component: 'adminOfferDetail'
      }
    };
    eventBus.$emit('setSideModalVisible', modalConfig);
  }

  onClickOffer(offer: any) {
    this.openOfferDetailModal(offer);
  }

  selectTab(tab: string) {
    this.tab = tab;
  }
}
